import 'css-chunksrc/feature/check-item/CheckItemPageNewEdit.module.scss';export default {
  "main_root": "CheckItemPageNewEdit_main_root",
  "main_container": "CheckItemPageNewEdit_main_container",
  "main_buttons": "CheckItemPageNewEdit_main_buttons",
  "main_cardScrollContainer": "CheckItemPageNewEdit_main_cardScrollContainer",
  "main_cardsContainer": "CheckItemPageNewEdit_main_cardsContainer",
  "discount_item": "CheckItemPageNewEdit_discount_item",
  "discount_info_icon": "CheckItemPageNewEdit_discount_info_icon",
  "discount_label": "CheckItemPageNewEdit_discount_label",
  "discount_calculated": "CheckItemPageNewEdit_discount_calculated",
  "discount_edit_icon": "CheckItemPageNewEdit_discount_edit_icon"
};